import React, { FC, useMemo } from "react";
import { Link } from "react-router";
import { Skeleton, Stack, Typography, IconButton } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { useQuery } from "@tanstack/react-query";
import { useStore } from "@tanstack/react-store";
import { projectsRequest } from "../../shared/requests";
import { DdbEnvironment } from "../../shared/types";
import { STORE } from "../store";
import { isTemplateQuery } from "../../shared/types";

export const CurrentQuery: FC = () => {
  const { currentQuery } = useStore(STORE);
  const projects = useQuery({
    queryKey: ["project-data", currentQuery.environment, currentQuery.project_id],
    queryFn: projectsRequest(currentQuery.project_id || ""),
  });

  // Memoize computed values to avoid unnecessary re-calculations
  const isFromTemplate = useMemo(() => isTemplateQuery(currentQuery), [currentQuery]);
  const projectUrl = useMemo(() => {
    switch (currentQuery.environment) {
      case DdbEnvironment.Production:
        return `https://ddb.arup.com/projects/${currentQuery.project_id}`;
      case DdbEnvironment.Sandbox:
        return `https://sandbox.ddb.arup.com/projects/${currentQuery.project_id}`;
      case DdbEnvironment.Develop:
        return `https://dev.ddb.arup.com/projects/${currentQuery.project_id}`;
      default:
        return `https://ddb.arup.com/projects/${currentQuery.project_id}`;
    }
  }, [currentQuery.environment, currentQuery.project_id]);

  return (
    <Stack direction="row" spacing={1} justifyContent={"end"} sx={{ width: "100%" }}>
      {projects.isLoading && <Skeleton variant="text" width={100} />}
      {projects.isSuccess && (
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" sx={{ width: "100%" }}>
          <Typography variant="body2" sx={{ textTransform: "uppercase" }}>
            {currentQuery.environment || ""}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2">{projects.data.get(currentQuery.project_id || "")?.project_number}</Typography>
            {!isFromTemplate && (
              <Link to={projectUrl} target="_blank" rel="noopener noreferrer">
                <IconButton>
                  <LinkIcon color="primary" />
                </IconButton>
              </Link>
            )}
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};
